import React from 'react';
import TicketDialog from './TicketDialog';

/**
 * The ? sheet: every key the ticket page answers to, and only the ones this
 * person has. Off while typing, and on a touch screen, where there is no
 * keyboard to press them on.
 */
export default function ShortcutsSheet({ onClose, tabs, can, contractor = false }) {
  const rows = [
    ['r', 'Write a reply'],
    ['Ctrl + Enter', 'Send it (⌘ + Enter on a Mac)'],
    ...tabs.map((t) => [`g ${t.short}`, `Go to ${t.label}`]),
    ...(can.canWork && tabs.some((t) => t.key === 'work') ? [['l', 'Log time']] : []),
    ...(can.canEdit ? [['s', 'Change the status'], ['a', 'Change who it is assigned to']] : []),
    ...(contractor ? [] : [['[', 'The previous ticket in the list you came from'], [']', 'The next one']]),
    ['?', 'This list'],
    ['Esc', 'Close a menu, or stop editing']
  ];
  return (
    <TicketDialog label="Keyboard shortcuts" onClose={onClose}>
      <dl className="tk-keys">
        {rows.map(([k, what]) => (
          <div key={k} className="tk-key-row">
            <dt>{k.split(' ').map((part, i) => (
              part === '+' ? <span key={i} className="tk-key-plus">+</span>
                : <kbd key={i} className="tk-kbd">{part}</kbd>
            ))}</dt>
            <dd>{what}</dd>
          </div>
        ))}
      </dl>
      <p className="tk-quiet tk-small">Shortcuts are off while you are typing in a box.</p>
    </TicketDialog>
  );
}
